import {useContext, useEffect, useState, cloneElement } from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../../common/AbstractListView";
import constants from '../../../../constants';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../../uiControls/UniqueLinkButton';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../../ui/ActionButton';
import PrimaryButton from '../../../../ui/PrimaryButton';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import {JobNames} from "../../../../framework.core/JobNames";
import {bankReconList} from "../../tableSettings";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import { BankRecActListItem } from '../../../../fms.data/models/BankRecActListItem';
import * as XCol from '../../../../framework.core/XExportColumn';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import BankReconActivityReportView from './report/BankReconActivityReportView';
import IfmsModal from "../../../../ui/IfmsModal";
import { FmsSecTask } from '../../../../fms.core/constants';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import { findSecurityTask } from '../../../../util';

/* 
function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;


  return (
    //<div className="ifms-table-default" style={{ width: '100%', minHeight: '22px', cursor: 'pointer' }} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}
*/

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  // const sourceUrl = `${history.location.pathname}${history.location.search}`;
  const operation = 'accounting';

  const selectedElement = jobListContext.selectedElement as BankRecActListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acBankRecon/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, `/${operation}/acBankRecon/add`, NavigationType.newPage);
  }

  async function deleteMbl() {
    if (!selectedElement) {
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.SeaQuotation, {
        id: selectedElement.id,
        pimsLinkId: 0
      });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message);
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/acBankRecon/edit/${id}`;
    const viewUrl = `/${operation}/acBankRecon/view/${id}`;
  
    if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/${operation}/acBankRecon/edit`, editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/acBankRecon/edit/${id}`;
    const viewUrl = `/${operation}/acBankRecon/view/${id}`;

    const listSec = findSecurityTask(appContext, FmsSecTask.AcctBankRecon);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acBankRecon/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/${operation}/acBankRecon/add?copyId=${id}`, NavigationType.newPage);
  }

  return {create, deleteMbl, edit, view, copy, operation};
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BankRecActListItem;
  const {edit,view, operation} = useSelectedOperations();
  const hasSelectedRow = !!selectedElement;
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctBankRecon);

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }
/*
  async function bankBalancePrint(){
    const toDate:string | undefined  = getDate(selectedElement.fDate)??"";
    const bankId:number | undefined  = selectedElement.bankId || 1;
    const currency:string | undefined  = selectedElement.currency??"";


    const title = "Bank Recon Activity";
    const args = new DailyAccountSub2Args({
      docType: DocumentType.DailyAccountSub2,
      formCaption: title,
      subject: title,

      userID: '', 
      edDate: toDate,
      bankID: bankId,
      valStr: currency + '|B|0'
    })
    viewReport(args, "", true);
  }
  */
  const canBeAdd = listSec?.grantAdd??true;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='bankRecon-list-add-button' display="primary" size="regular" link={`/${operation}/acBankRecon/add`} disabled={!canBeAdd} label="New"/>&nbsp;
        <PrimaryButton name='bankRecon-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='bankRecon-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;     
        {/* <PrimaryButton size="regular" onClick={bankBalancePrint} >Bank Balance</PrimaryButton>&nbsp; */}
        <PrimaryButton name='bankRecon-list-print-button' size="regular" onClick={() => setSelectedPopupMenuItem({label: 'Bank Recon Activity Report', popupComponent: <BankReconActivityReportView /> })}>Print</PrimaryButton>
        {/* <PrimaryButton size="regular">Print</PrimaryButton>&nbsp; */}
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 400}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}){
  const {create, edit, view} = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctBankRecon);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: true , hidden: !listSec?.grantEdit },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Refresh', shortcut: 'F11', separator: false},
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
    hidden: i?.hidden ?? false,
  }));

  
  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        jobListContext.triggerTableSearch('F5');
        break;
      case 4:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );


}


function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  const {create, edit, view} = useSelectedOperations();

  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctBankRecon);
  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }
    // } else if (unprocessedFkey === "F7") {
    //   jobListContext.setInfoAreaContent('custom');
    // }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.BankRecon}
      jobId={(jobListContext.selectedElement as BankRecActListItem|null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

function formatData(data:Array<BankRecActListItem>) {
  return data;
}

/**
 * Concrete implementation for Quotation List screen
 *
 * @class BankReconListView
 * @extends {AbstractListView}
 */
class BankReconListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.BankRecon, 'BankRecActListItem',
    BankRecActListItem.calculateSearchParameters(search, BankRecActListItem.MapSearchFields),
      1,
      search.pageSize);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      // {
      //   accessor: 'statusNotUseFileLocked',
      //   renderer: StatusNotUseFileLockedRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
    ];
  }

 
  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    // return [
    //   {accessor: 'u1Date', Cell: DateTimeRenderer},
    //   {accessor: 'u2Date', Cell: DateTimeRenderer},
    //   {accessor: 'reconDate', Cell: DateRenderer},

    //   {accessor: 'bank', Cell: TextAlignLeftRenderer},
    //   {accessor: 'currency', Cell: TextRenderer},
    //   {accessor: 'remark', Cell: TextAlignLeftRenderer},
    //   {accessor: 'inAmount', Cell: ({cell}: any) => <FloatRenderer cell={cell} decimals={2}/>},
    //   {accessor: 'outAmount', Cell: ({cell}: any) => <FloatRenderer cell={cell} decimals={2}/>},
    //   {accessor: 'balance', Cell: ({cell}: any) => <FloatRenderer cell={cell} decimals={2}/>},
    //   {accessor: 'processingDeposit', Cell: ({cell}: any) => <FloatRenderer cell={cell} decimals={2}/>},
    //   {accessor: 'bankValue', Cell: ({cell}: any) => <FloatRenderer cell={cell} decimals={2}/>},
    //   {accessor: 'difference', Cell: ({cell}: any) => <FloatRenderer cell={cell} decimals={2}/>},
    //   {accessor: 'u1ID', Cell: TextAlignLeftRenderer},
    //   {accessor: 'u2ID', Cell: TextAlignLeftRenderer},
    // ];
    return BankRecActListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };

      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.type === XCol.XCellType.Double) colRenderer.Cell = FloatRenderer;

      // if (x.dataIndex === "status") {
      //   colRenderer.Cell = IndicatorRenderer;
      // }

      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }
  
  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'updated',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  bankReconList;
    const cols = BankRecActListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  getViewUrlFor(row: BankRecActListItem) {
    return row && row.id ? `/accounting/acBankRecon/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Bank Recon List';
  };
}

export default BankReconListView;